import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'list-clock',
  size: 24,
  node: [
    ['path', { d: 'M16 13v2.2l1.6 1', key: '1bc147' }],
    ['path', { d: 'M3 12h3.458', key: 'brzde3' }],
    ['path', { d: 'M3 19h3.832', key: '1d2y74' }],
    ['path', { d: 'M3 5h18', key: '1u36vt' }],
    ['circle', { cx: '16', cy: '15', r: '6', key: '1cvf88' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name ListClock
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMTN2Mi4ybDEuNiAxIiAvPgogIDxwYXRoIGQ9Ik0zIDEyaDMuNDU4IiAvPgogIDxwYXRoIGQ9Ik0zIDE5aDMuODMyIiAvPgogIDxwYXRoIGQ9Ik0zIDVoMTgiIC8+CiAgPGNpcmNsZSBjeD0iMTYiIGN5PSIxNSIgcj0iNiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/list-clock
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ListClock = createLucideIcon(__iconData);

export default ListClock;
